import React from "react";

import Label from "../../ui_atoms/Label";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";

function StoryComponent({ text }: { text: string }) {
    return (
        <VStack
            gap={0.5}
            h={1}
            style={{
                margin: 10,
                alignSelf: "stretch",
            }}
        >
            <Label text={text} mode="info" />
            <Label text={text} mode="success" />
            <Label text={text} mode="error" />
            <Label text={text} mode="warning" />
            <Label text={text} mode="default" />
            <Label
                text="This is a multiline\nlabel with a lot of useless informtion, but this is juste to text the multiline and avoid the elipsis"
                mode="default"
                multiline
            />
        </VStack>
    );
}

const meta = {
    title: "Atom/Labels",
    component: StoryComponent,
    argTypes: {},
    parameters: {
        sherlo: {
            exclude: false,
        },
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        text: "This is a label",
    },
};
